<template>
  <div v-if="this.showModal" class="checkout-success-modal">
    <div class="checkout-success-modal-overlay" @click="closeModal"></div>
    <div class="checkout-success-modal-content">
      <div class="checkout-success-modal-text">
        <span>{{ t('checkout-success-modal-title') }}</span>
        <p>{{ t('checkout-success-modal-text') }}</p>
      </div>
      <Lottie
        class="lottie-wrapper"
        ref="lottie"
        :animation-data="lottieFile"
        :auto-play="true"
        :loop="true"
        width="100%"
        height="100%"
      />
      <button class="close-btn" @click="closeModal">X</button>
    </div>
  </div>
</template>

<script>
import Lottie from './Lottie.vue'
import checkoutSuccessBg from '../lotties/success.json'

export default {
  name: 'checkoutSuccessLottie',
  components: {
    Lottie
  },
  data() {
    return {
      showModal: true
    }
  },
  computed: {
    lottieFile() {
      return checkoutSuccessBg
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  z-index: 3;
}

.checkout-success-modal {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkout-success-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.checkout-success-modal-content {
  position: relative;
  background-color: #1C1D1E;
  border-radius: 33px;
  padding:30px;
  min-width: 50vw;
  min-height: 50vh;
  margin-top: 140px;
  @media screen and (max-width:767px){
    width: 90%;
  }
}

.lottie-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
}

.checkout-success-modal-text{
  text-align: center;
  left:0;
  right:0;
  margin: 0 auto 20px auto;
  top:50%;
  transform: translateY(-50%);
  z-index: 2;
  line-height: 1.3;
  position: absolute;
  padding:30px;
  span, p{
    display: block;
    width: 100%;
  }
  span{
    color:var(--prime2);
    font-weight: 700;
    font-size: 40px;
    @media screen and (max-width:767px){
      font-size: clamp(0.875rem, 2.5vw, 25px);
    }
  }
  p{
    color:#fff;
    font-size: 20px;
    margin: 15px 0 0 0;
    @media screen and (max-width:767px){
      font-size: 16px
    }
  }
}
</style>
